














import { Component, Vue } from 'vue-property-decorator'
import CommonButton from '@/components/common/CommonButton.vue'
import AuthDefaultContainer from '@/components/auth/AuthDefaultContainer.vue'
import { User } from '@/services/types'
import { mapGetters } from 'vuex'

@Component({
  components: { AuthDefaultContainer, CommonButton },
  computed: {
    ...mapGetters('auth', { user: 'getUser' }),
  },
})
export default class NotFound extends Vue {
  user!: User | null

 onButtonClick(): void {
     window.location.href = '/'
  }
}
